import { render } from "./DashboardLtba.vue?vue&type=template&id=0c481de6&scoped=true"
import script from "./DashboardLtba.vue?vue&type=script&lang=js"
export * from "./DashboardLtba.vue?vue&type=script&lang=js"

import "./DashboardLtba.vue?vue&type=style&index=0&id=0c481de6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c481de6"]])

export default __exports__